import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/theme/tokens.css";
import { App } from "@/app/App";
import { WebLandingApp } from "@/app/WebLandingApp";
import { ErrorBoundary } from "@/app/ErrorBoundary";

const queryClient = new QueryClient();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {Capacitor.isNativePlatform() ? <App /> : <WebLandingApp />}
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
